import React from "react";
import "./login.css";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { login } from "../schemas";
import { getRoleHomePath } from "../../utils/roleHome";
import UserServices from "../../UserServices/UserServices";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useContext } from "react";
import { NoteState } from "../../context/notes/NoteState";
import logo from "../../../src/icons/logo.png";


export default function Login() {
  const { dispatch: ctxDispatch } = useContext(NoteState);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const initialValues = {
    email: "",
    password: "",
  };
  const Login = async (values) => {
    try {
      setLoading(true);
      const response = await UserServices.Login(values);
      if (response.status === 200) {
        const token = response.data.access_token;
        let tokenIsClient = false;
        try {
          // Client JWTs include typ/guard claims from the api_client guard
          const payload = JSON.parse(atob(token.split(".")[1]));
          tokenIsClient =
            payload?.typ === "client" || payload?.guard === "api_client";
        } catch (_) {
          tokenIsClient = false;
        }
        const accountType =
          response.data.account_type ||
          (tokenIsClient ? "client" : "staff");
        const branchId = response.data.user.branch_id || "";
        const userRole = String(
          response.data.user.role ?? (tokenIsClient ? "client" : "")
        );
        const designationId =
          response.data.user.designation_id ??
          response.data.user.designationId ??
          null;
        const mustChange = !!response.data.user.must_change_password;
        const isClient =
          accountType === "client" ||
          userRole === "client" ||
          tokenIsClient;
        ctxDispatch({
          type: "LOGIN",
          accessToken: token,
          branchId: branchId,
          UId: response.data.user.id,
          role: isClient ? "client" : userRole,
          designationId: isClient ? null : designationId,
          accountType: isClient ? "client" : accountType,
          mustChangePassword: mustChange,
        });
        setLoading(false);
        if (isClient) {
          if (mustChange) {
            navigate("/client-change-password", { replace: true });
          } else {
            navigate("/client-dashboard", { replace: true });
          }
          return;
        }
        navigate(getRoleHomePath(userRole, designationId), { replace: true });
      }
    } catch (err) {
      setLoading(false);
      const status = err.response?.status;
      if (status === 401) {
        toast.error("Wrong email or password!", { position: "top-center" });
      } else if (status === 422) {
        toast.error("Unproccessable content!", { position: "top-center" });
      } else if (status === 403) {
        toast.error(
          err.response?.data?.message || "Access denied for your role.",
          { position: "top-center" }
        );
      } else {
        toast.error("Login failed. Please try again.", { position: "top-center" });
      }
    }
  };
  //validation........................................................................................
  const { values, errors, touched, handleChange, handleBlur, handleSubmit } =
    useFormik({
      initialValues: initialValues,
      validationSchema: login,
      onSubmit: (values) => {
        Login(values);
      },
    });
  return (
    <div className="login-page">
       <ToastContainer />
      <div className="pen-title">
        <img src={logo} alt="" />
        <br />
        <span>DASHBOARD LOGIN</span>
      </div>
      <div className="container">
        <div className="card">
          <h1 className="title">Login</h1>
          <form onSubmit={handleSubmit}>
          <label htmlFor="#{email}" className="lable">Email</label>
            <div className="input-container">
              <input
                placeholder=""
                type="email"
                id="#{email}"
                name="email"
                autoComplete="off"
                value={values.email || ""}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              <div className="bar" />
              {errors.email && touched.email ? (
                <p className="text-danger">{errors.email}</p>
              ) : null}
            </div>
            <label htmlFor="#{password}" className="lable">Password</label>
            <div className="input-container">
              <input
                type="password"
                placeholder=""
                id="#{password}"
                name="password"
                autoComplete="off"
                value={values.password || ""}
                onChange={handleChange}
                onBlur={handleBlur}
              />
             
              <div className="bar" />
              {errors.password && touched.password ? (
                <p className="text-danger">{errors.password}</p>
              ) : null}
            </div>
            <div className="button-container">
              <button type="submit">
                <span>Login</span>
              </button>
            </div>
           
          </form>
        </div>
      </div>
      <div className={`loader ${loading ? "in" : ""}`}>
        <div className="spinner-border main-spin"></div>
      </div>
    </div>
  );
}


